import { atom } from 'recoil';

let loanList = atom<any>({
  key: 'loanList',
  default: {
    preRequestInfoChk: '',
    dayAgo: '',
    toDayRemainTime: '',
    minInterestProductItem: '',
    maxAmountProductItem: '',
    practiceProductItemList: '',
    failProductItemList: '',
    rejectProductItemList: '',
    searchedPreProductList: '',
    applyingProductList: '',
    cancelProductList: '',
    practiceProductList: '',
  },
});

export { loanList };
